import React, { Component } from 'react';


import Header from '../components/header/Header';
import Banner from '../components/banner/Banner';
import Auth from '../components/auth/Auth';
import Footer from '../components/footer/Footer';
import Addresses from '../components/addresses/Addresses';
import Checkout from '../components/checkout/Checkout'
import landingService from '../services/landing.service'
import couponService from '../services/coupon.service'
import orderService from '../services/order.service';
import userService from '../services/user.service';
import Success from '../components/pages/Success';
import ProductsRecipeList from '../components/products-recipe-list/ProductsRecipeList';
import ENV from '../environments/environment';

declare var $;
declare var fbq;

class Promo extends Component {

  constructor(props) {
      super(props);
      this.state = {
        dataCoupon: [],
        loading: true,
        logued: false,
        addressSelected: false,
        selectedAddress: [],
        error: '',
        couponData: [],
        userData: null,
        shippingValue: 0,
        step: 1,
        auth: false,
        products: [],
        landingData: [],
        store_id: 0,
        selectedProducts: [],
        storeType: ''
      };
      this.logout = this.logout.bind(this)
      this.stepBack = this.stepBack.bind(this)
      this.getUserData = this.getUserData.bind(this)
      this.getShippingCharges =   this.getShippingCharges.bind(this)
      this.nextStep =  this.nextStep.bind(this)
      this.setAuthScreen =  this.setAuthScreen.bind(this)
      this.getStoreData =  this.getStoreData.bind(this)
      this.handleSelectedProducts = this.handleSelectedProducts.bind(this)
    }


  async componentWillMount() {

      let dataCoupon = await landingService.getLandingData(this.props.match.params.token);
        dataCoupon = dataCoupon.data;
        if(dataCoupon.country) {
          let pixel =  dataCoupon.facebook_pixel
          this.setState({ dataCoupon, loading: false })
          fbq('init', pixel);
          fbq('track', 'PageView');
          fbq('track', 'ViewContent', {
              content_name: 'offer'
          })
          localStorage.setItem('country', dataCoupon.country)
          this.getStoreData(dataCoupon.products, dataCoupon.store_type);
          if(dataCoupon.fb_only) {
           // this.isFacebookApp()
          }
       } else {
         document.location.href = '/404'
       }
  }


  async getStoreData(prd, storeType) {
    let products_id = [];
    prd.forEach(p => {
      products_id.push(p.id);
    })
    let coords = [4.678623300000,-74.055495800000]
    let response = await landingService.getProducts(products_id, coords, storeType)
    response = response.data;
    let products = response.products;
    let store_id = response.store_id
    if(products) {
       if (this.props.match.params.token) {
          localStorage.setItem('accessToken', this.props.match.params.token);
       }
      let userData = [];
      this.setState({
        products,
        landingData: response,
        store_id,
        storeType
      })
    }
  }

  componentDidMount() {
    localStorage.removeItem('accessToken')
    localStorage.removeItem('user_data')
  }

  isFacebookApp() {
     var ua = navigator.userAgent || navigator.vendor;
     if( !( (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1) )) {
       document.location.href = '/403'
     }
   }

  handleAuth(e) {
    this.getUserData()
  }

async handleSelectedAddress(address) {
     this.setState({
       selectedAddress: address,
       error: ''
    })
    if(this.state.dataCoupon.coupon_code) {
          let coupon = {
          coupon: {
            code: this.state.dataCoupon.coupon_code,
            lng: address.lng,
            lat: address.lat,
            purchase_type: "now",
            token: localStorage.getItem('accessToken')
          }
        }
        let response = await couponService.redeemCoupon(coupon)
          if(!response.message_error) {
              response = response.data;
            response.coupon_code = this.state.dataCoupon.coupon_code;
            response.cc_only = this.state.dataCoupon.cc_only;
            if( !response.shipping ) {
                //this.getShippingCharges(address.lng, address.lat);
            }
            let localProducts = [];
            const ps = JSON.parse(localStorage.getItem('products'));
            response.products.forEach((product) => {
                ps.forEach((p) => {
                  if(p.id === Number(product.id.split('_')[1])) {
                    let pr = {...product}
                    pr.units = p.units;
                    pr.total_price = p.total_price;
                    localProducts.push(pr)
                  }
                });
            });
            response.products = localProducts;
            localStorage.setItem('products', JSON.stringify(localProducts));
            let step = this.state.step + 1;
            this.setState({
              couponData: response,
              step
            })
          } else {
            this.setState({
              error: response.message_error
            })
          }
    } else {
      let prs = []
      this.state.products.forEach(
        p => {
          prs.push( Number(p.id.split('_')[1]));
        }
      )
      const { data } = await landingService.getProducts(prs, [address.lat , address.lng], this.state.storeType);

      let localProducts = [];
      const ps = JSON.parse(localStorage.getItem('products'));
      data.products.forEach((product) => {
          ps.forEach((p) => {
            if(Number(p.id.split('_')[1]) === Number(product.id.split('_')[1])) {
              let pr = {...product}
              pr.units = p.units;
              pr.image = p.image
              pr.total_price = p.total_price;
              localProducts.push(pr)
            }
          });
      });

      data.products = localProducts;
      localStorage.setItem('products', JSON.stringify(localProducts));
      let step = this.state.step + 1;
      this.setState({
        couponData: data,
        step
      })
    }
  }

  async getShippingCharges(lng,lat) {
    let response = await orderService.getShippingCharges(lat ,lng)
    let  shippingCharge = response[this.state.dataCoupon.store_type];
    let shippingValue = shippingCharge[0].value;
    this.setState({
      shippingValue
    })
  }

  async getUserData(step) {
    let response = await userService.getUserData()
    this.setState({
      userData: response,
      step
    });
    localStorage.setItem('user_data', JSON.stringify(response))
  }

  logout() {
    this.setState({
      logued: false,
      addressSelected: false
    })
    localStorage.removeItem('accessToken')
  }

  stepBack() {
    this.setState({
      addressSelected: false
    })
  }

  setAuthScreen(auth) {
    this.setState({
      auth
    })
  }

  nextStep(step) {
    if(step != 4 || localStorage.getItem('user_data')) {
     this.setState({
       step
     })
   } else {
     this.getUserData(step)
   }
  }


  handleSelectedProducts(selectedProducts) {
    selectedProducts =  JSON.parse(JSON.stringify(selectedProducts))
     for(let product of selectedProducts) {
       product.image = ENV.getImageUrl() + product.image;
     }
    this.setState({
      selectedProducts
    })
    localStorage.setItem('products', JSON.stringify(selectedProducts))
    let step = this.state.step + 1;
    this.setState({
      step
    })
 }

  render() {
    return (
      
        <div>
             { /*  <div className="store">
            <div className="content-wrapper">
            { (this.state.step === 1 && !this.state.cart) &&
            <div>
            <StoreBanner coupon_code={this.props.match.params.coupon_code}  copy={this.props.match.params.copy} subcopy={this.props.match.params.subcopy}></StoreBanner>
            <section>
            <ProductList  store_id={this.state.store_id} partiallySelectedProducts={this.handlePartiallySelectedProducts.bind(this)}  selected={this.handleSelectedProducts.bind(this)} products={this.state.products}/>
            </section>
            { !this.state.landingData.products && <h3 className="text-center unavaliable">Ups, no hay productos disponibles :(</h3>}
            </div>
            }

            { (this.state.step === 2 && !this.state.cart)  && <Addresses cart={this.handleCart.bind(this)} step={this.state.step} continue={this.nextStep.bind(this)} auth="true" userData={this.state.userData} error={this.state.error} setSelectedAddress={this.handleSelectedAddress.bind(this)}></Addresses> }
            { (this.state.step === 3 && !this.state.cart) && <Checkout cart={this.handleCart.bind(this)} step={this.state.step}  showProducts="false"  step={this.state.step} continue={this.nextStep.bind(this)} selectedAddress={this.state.selectedAddress} couponData={this.state.couponData}></Checkout> }
            { (this.state.step === 4 && !this.state.cart) && <Success></Success> }

            { this.state.cart && <Cart cart={this.handleCart.bind(this)}></Cart> }

            </div>
          </div> */ }
          <div className="store">
            {this.state.step === 1 &&  <Banner   screen={this.setAuthScreen.bind(this)}   step={this.state.step} continue={this.nextStep.bind(this)} dataCoupon={this.state.dataCoupon}></Banner> }
            {this.state.step === 2  &&  <ProductsRecipeList screen={this.setAuthScreen.bind(this)}   store_id={this.state.store_id} step={this.state.step} continue={this.nextStep.bind(this)}  selected={this.handleSelectedProducts.bind(this)} products={this.state.products}/> }
            { this.state.step === 3  && <Auth  auth={this.state.auth}  step={this.state.step} continue={this.nextStep.bind(this)}></Auth> }
            { this.state.step === 4 && <Addresses  step={this.state.step} continue={this.nextStep.bind(this)} userData={this.state.userData} error={this.state.error} setSelectedAddress={this.handleSelectedAddress.bind(this)}></Addresses> }
            { this.state.step === 5  && <Checkout step={this.state.step} continue={this.nextStep.bind(this)} shippingValue={this.state.shippingValue} showProducts="true" selectedAddress={this.state.selectedAddress} couponData={this.state.couponData}></Checkout> }
            { (this.state.step === 6 && !this.state.cart) && <Success></Success> }
          </div>
        </div>
    );
  }
}




export default Promo;



// WEBPACK FOOTER //
// ./src/modules/Promo.js